import { render } from "./quick-add.vue?vue&type=template&id=0f49966d"
import script from "./quick-add.vue?vue&type=script&lang=js"
export * from "./quick-add.vue?vue&type=script&lang=js"

import "./quick-add.vue?vue&type=style&index=0&id=0f49966d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__